module.exports = __webpack_public_path__ + "static/img/weixuanzhongyouxi.png@2x.c67b9ce6.png";